export default __webpack_public_path__ + "static/showcase-0e3b0aa716e0ab8a052699e78fb0113a.png";